<template>
  <div class="specimens-imgs">
    <control
      :count="imgs.length"
      :creating="creating"
      @create="onCreate"
    ></control>
    <div v-if="!loading && !Boolean(imgs.length)" class="no-data">
      暂无数据……
    </div>

    <el-scrollbar
      v-else
      v-loading="loading"
      class="flex-scrollbar"
      wrap-class="default-scrollbar__wrap"
    >
      <div class="specimens-list">
        <div class="specimens-col" v-for="(col, r) in waterFall" :key="r">
          <div class="specimens-row" v-for="(row, c) in col" :key="c">
            <div
              class="specimens-item"
              @mouseover="hover(row)"
              @mouseout="mouseout"
            >
              <el-image :src="row.tempPath" @click="showPhoto(row)">
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="error">
                  加载失败
                </div>
              </el-image>
              <el-button
                class="specimens-del"
                circle
                icon="el-icon-close"
                size="mini"
                v-show="hoverImg === row.id"
                @click="remove(row)"
              ></el-button>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener
} from 'element-ui/src/utils/resize-event'
import { debounce } from '@/utlis'
import { list, create, remove } from '@/service/specimen'
import showImgDetail from './modal'
import Control from './control'

export default {
  components: { Control },
  props: { id: [Number, String] },
  data() {
    return {
      creating: false,
      loading: false,
      imgs: [],
      waterFall: [],
      hoverImg: '',
      resizeHandler: null
    }
  },
  mounted() {
    this.getData()
    this.resizeHandler = debounce(this.resize, 200)
    addResizeListener(this.$el, this.resizeHandler)
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.resizeHandler)
  },
  methods: {
    createFormData(form, file) {
      const formData = new FormData()

      // JSON 内容写入 formData
      Object.keys(form).forEach(key => {
        formData.append(key, form[key])
      })

      // 待上传的文件 写入 formData
      formData.append('specimen', file)

      return formData
    },
    async getData() {
      this.loading = true

      const { data } = await list({
        companyId: this.companyId,
        categoryId: this.id
      })

      this.loading = false
      this.imgs = data
      this.waterFall = this.formatData(data)
    },
    formatData(imgs) {
      const width = this.$el.offsetWidth
      const cols = Math.ceil(width / 400)
      const rows = Math.ceil(imgs.length / cols)

      let data = []

      for (let c = 0; c < cols; c++) {
        let col = []

        for (let r = 0; r < rows; r++) {
          let i = r * cols + c
          if (imgs[i]) {
            col.push(imgs[i])
          }
        }
        if (col[0]) {
          data.push(col)
        }
      }
      return data
    },
    async remove(img) {
      try {
        await this.$confirm('确定删除样本？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const { code } = await remove(img.id)
        if (code) {
          let index = this.imgs.findIndex(i => i.id === img.id)
          this.imgs.splice(index, 1)
          this.waterFall = this.formatData(this.imgs)
        }
      } catch {
        this.$message({ type: 'info', message: '取消删除' })
      }
    },
    resize() {
      this.waterFall = this.formatData(this.imgs)
    },
    showPhoto(row) {
      showImgDetail({
        id: row.id,
        list: this.imgs.map((img, i) => ({
          ...img,
          thumb: img.tempPath,
          src: img.storePath,
          title: `${img.name}-${i + 1}`
        }))
      })
    },
    async onCreate(file) {
      try {
        this.creating = true
        const form = this.createFormData({ categoryId: this.id }, file)
        const { data, code } = await create(form)

        if (code) {
          this.imgs.push(data)
          this.waterFall = this.formatData(this.imgs)
          this.$message('上传成功')
        }
        this.creating = false
      } catch {
        this.creating = false
      }
    },
    hover(img) {
      this.hoverImg = img.id
    },
    mouseout() {
      this.hoverImg = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.specimens-imgs {
  height: 100%;
  .no-data {
    min-height: 400px;
  }
  .flex-scrollbar.el-scrollbar {
    height: calc(100% - 50px);
  }
  .specimens-list {
    display: flex;
  }
  .specimens-col {
    flex: 1;
    display: inline-block;
    margin-top: 12px;
    margin-right: 12px;
    max-width: 400px;
  }
  .specimens-item {
    margin-bottom: 12px;
    position: relative;
  }
  .specimens-item .el-image {
    cursor: pointer;
    width: 100%;
    .error {
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 240px;
      width: 100%;
      background-color: #e4e7ed;
      color: #c0c4cc;
    }
  }
  .specimens-del {
    position: absolute;
    right: 1rem;
    top: 1rem;
    transition: all 0.2s ease;
  }
}
</style>
